import { combineReducers } from 'redux'
import { CommonState, CommonReducer } from './common/common.reducer'
import { PostingState, PostingReducer } from './posting/posting.reducer'
import { FacebookState, facebookReducer } from './facebook/facebook.reducer'
import { InstagramState, instagramReducer } from './instagram/instagram.reducer'
import { googleMyBusinessReducer, GoogleMyBusinessState } from './googleMyBusiness/googleMyBusiness.reducer'
import { linkedInReducer, LinkedInState } from './linkedIn/linkedIn.reducer'

export interface ApiError {
  [key: string]: Response | Error | Record<string, unknown> | undefined
}

export interface PostingRootState {
  facebookStore: FacebookState
  instagramStore: InstagramState
  linkedInStore: LinkedInState
  googleMyBusinessStore: GoogleMyBusinessState
  commonStore: CommonState
  postingStore: PostingState
}

export const postingRootReducer = combineReducers<PostingRootState>({
  facebookStore: facebookReducer,
  instagramStore: instagramReducer,
  linkedInStore: linkedInReducer,
  googleMyBusinessStore: googleMyBusinessReducer,
  commonStore: CommonReducer,
  postingStore: PostingReducer,
})
